import { render } from "./DistributionModalRule.vue?vue&type=template&id=0e7fb474&scoped=true"
import script from "./DistributionModalRule.vue?vue&type=script&lang=js"
export * from "./DistributionModalRule.vue?vue&type=script&lang=js"

import "./DistributionModalRule.vue?vue&type=style&index=0&id=0e7fb474&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7fb474"]])

export default __exports__